<div class="w-full">
  <div
    class="w-full max-w-full overflow-hidden border border-stroke-soft bg-white rounded-t-lg"
    [class.rounded-b-lg]="!showPagination()"
  >
    <div [style.min-width]="minWidth()">
      <div class="h-13 bg-surface-card border-b border-stroke-soft"></div>
      @for (row of rowsArray(); track row) {
      <div class="flex items-center h-16 border-b border-stroke-soft">
        @for (column of columns(); track $index) {
        <div
          [class]="'flex flex-col justify-center gap-1.5 px-6 ' + (column.cellClass ?? 'flex-1')"
          [style.min-width]="column.minWidth ?? null"
        >
          @for (line of column.lines; track $index) {
          <div [class]="line + ' overflow-hidden rounded'">
            <dss-libs-ui-skeleton />
          </div>
          }
        </div>
        }
      </div>
      }
    </div>
  </div>

  @if (showPagination()) {
  <div
    class="h-18 px-6 bg-white border border-t-0 border-stroke-soft rounded-b-lg flex items-center justify-center lg:justify-between gap-4"
  >
    <div class="hidden lg:flex items-center gap-4">
      <div class="w-28 h-8.25 overflow-hidden rounded-md">
        <dss-libs-ui-skeleton />
      </div>
      <div class="w-40 h-4 overflow-hidden rounded">
        <dss-libs-ui-skeleton />
      </div>
    </div>

    <div class="flex items-stretch h-8.25 shrink-0">
      <div class="w-20 overflow-hidden rounded-s border border-e-0 border-stroke-soft">
        <dss-libs-ui-skeleton />
      </div>
      <div class="flex border-y border-stroke-soft">
        @for (block of [1, 2, 3]; track block) {
        <div class="w-8 overflow-hidden border-s border-stroke-soft">
          <dss-libs-ui-skeleton />
        </div>
        }
      </div>
      <div class="w-16 overflow-hidden rounded-e border border-stroke-soft">
        <dss-libs-ui-skeleton />
      </div>
    </div>
  </div>
  }
</div>
